import React from "react"

import { isTestSetType, TestSetType } from "@/types/TestSetInput"

import type { EditableTestCase } from "../../../model"
import { AudioInputCell } from "./AudioInputCell"
import { DefaultInputCell } from "./DefaultInputCell"
import { ScriptInputCell } from "./ScriptInputCell"

interface TestCaseInputCellProps {
  testCase: EditableTestCase
  pendingEdit: Partial<EditableTestCase> | null
  isExpanded: boolean
  isMarkedForDeletion: boolean
  onUpdate: (updates: Partial<EditableTestCase>) => void
  width: string
}

/** Routes to the appropriate input cell sub-component based on test case type. */
export const TestCaseInputCell: React.FC<TestCaseInputCellProps> = (props) => {
  const { testCase, pendingEdit, ...rest } = props
  const inputType = isTestSetType(testCase.input_type)
    ? testCase.input_type
    : null

  if (inputType === TestSetType.SCRIPT) {
    return (
      <ScriptInputCell
        testCase={testCase}
        pendingEdit={pendingEdit}
        isExpanded={rest.isExpanded}
        onUpdate={rest.onUpdate}
        width={rest.width}
      />
    )
  }

  if (
    inputType === TestSetType.AUDIO &&
    testCase.s3_key &&
    testCase.s3_bucket
  ) {
    return (
      <AudioInputCell
        testCase={testCase}
        isExpanded={rest.isExpanded}
        width={rest.width}
      />
    )
  }

  return <DefaultInputCell testCase={testCase} {...rest} />
}
